import { render, staticRenderFns } from "./tags-manage-dialog.vue?vue&type=template&id=3d60de52&scoped=true"
import script from "./tags-manage-dialog.vue?vue&type=script&lang=js"
export * from "./tags-manage-dialog.vue?vue&type=script&lang=js"
import style0 from "./tags-manage-dialog.vue?vue&type=style&index=0&id=3d60de52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d60de52",
  null
  
)

export default component.exports